import PurchaseModalItem from "./purchase-modal-item";

export default PurchaseModalItem;